module.exports = __webpack_public_path__ + "img/bg1.661dd64c.png";